import { render, staticRenderFns } from "./ReferralLetter.vue?vue&type=template&id=7ad0453a&scoped=true"
import script from "./ReferralLetter.vue?vue&type=script&lang=js"
export * from "./ReferralLetter.vue?vue&type=script&lang=js"
import style0 from "./ReferralLetter.vue?vue&type=style&index=0&id=7ad0453a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad0453a",
  null
  
)

export default component.exports